import { getColor } from './helpers';

const strokeWidth = 5;

interface IProps {
  radius: number;
  secondsCount: number;
}

export const TimerDonutChart = ({ radius, secondsCount }: IProps) => {
  const percentage = Math.min(100, (secondsCount / 60 / 40) * 100);

  const color = getColor(percentage);

  return (
    <svg width={radius * 2} height={radius * 2}>
      {percentage === 0 || percentage === 100 ? (
        <circle
          r={radius - strokeWidth / 2}
          cx={radius}
          cy={radius}
          strokeWidth={strokeWidth}
          stroke={percentage === 0 ? '#F7F9FA' : color}
          fill="none"
        />
      ) : (
        <>
          <path
            d={`M${radius},${strokeWidth} V0 A${radius},${radius} 0 ${percentage > 50 ? 1 : 0},1 ${
              radius * (1 + Math.sin((2 * Math.PI * percentage) / 100))
            },${radius * (1 - Math.cos((2 * Math.PI * percentage) / 100))} L${
              strokeWidth +
              (radius - strokeWidth) * (1 + Math.sin((2 * Math.PI * percentage) / 100))
            } ${
              strokeWidth +
              (radius - strokeWidth) * (1 - Math.cos((2 * Math.PI * percentage) / 100))
            } A${radius - strokeWidth},${radius - strokeWidth} 0 ${
              percentage > 50 ? 1 : 0
            },0 ${radius},${strokeWidth} Z`}
            fill={color}
          />
          <path
            d={`M${
              strokeWidth +
              (radius - strokeWidth) * (1 + Math.sin((2 * Math.PI * percentage) / 100))
            },${
              strokeWidth +
              (radius - strokeWidth) * (1 - Math.cos((2 * Math.PI * percentage) / 100))
            } L${radius * (1 + Math.sin((2 * Math.PI * percentage) / 100))} ${
              radius * (1 - Math.cos((2 * Math.PI * percentage) / 100))
            } A${radius},${radius} 0 ${
              100 - percentage > 50 ? 1 : 0
            },1 ${radius}, 0 L${radius} ${strokeWidth} A${radius - strokeWidth},${
              radius - strokeWidth
            } 0 ${100 - percentage > 50 ? 1 : 0},0 ${
              strokeWidth +
              (radius - strokeWidth) * (1 + Math.sin((2 * Math.PI * percentage) / 100))
            },${
              strokeWidth +
              (radius - strokeWidth) * (1 - Math.cos((2 * Math.PI * percentage) / 100))
            } Z`}
            fill="#F7F9FA"
          />
        </>
      )}
      <text
        x={radius}
        y={radius}
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize="14"
        fontWeight="500"
        fontFamily="Roboto"
        fill="#143062"
      >
        {Math.trunc(percentage)}%
      </text>
    </svg>
  );
};

export default {};
